import React from 'react';

import { Search } from '@work4all/components/lib/input/actions/search/Search';

interface Props {
  label?: string;
  value: string;
  onChange: (value: string) => void;
}

export const SearchActionV8: React.FC<Props> = (props: Props) => {
  const { value, onChange } = props;

  return (
    <Search
      value={value}
      onChange={(e) => onChange(e?.target.value || '')}
      fieldStyle="fill"
      label={props.label}
    />
  );
};
